// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"5eb46ff6","56":"ebe871da","60":"44778b4d","340":"fd4da89f","380":"16d87382","715":"a81331c5","821":"2f6120a0"}[chunkId] + ".chunk.css";
};